import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconCheck: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.6585 0.247422C16.0742 0.611104 16.1163 1.24287 15.7526 1.6585L6.12759 12.6585C5.9377 12.8755 5.66338 13 5.37501 13C5.08665 13 4.81233 12.8755 4.62244 12.6585L0.247437 7.6585C-0.116245 7.24287 -0.0741276 6.6111 0.341509 6.24742C0.757146 5.88374 1.38891 5.92586 1.75259 6.34149L5.37501 10.4814L14.2474 0.341494C14.6111 -0.0741428 15.2429 -0.11626 15.6585 0.247422Z"
      />
    </svg>
  </IconStyled>
);

IconCheck.defaultProps = iconDefaultProps;
IconCheck.displayName = 'IconCheck';

export default IconCheck;
